import { action, observable, computed } from "mobx"

export default class OrderlistStoreV2 {
  @observable isOpenSelectionModal = false
  @observable currentProduct       = null
  @observable currentListId        = null

  constructor( shop ) {
    this._shop = shop
  }

  // Derived from the service so it always reflects current list data.
  @computed get currentList() {
    if ( !this.currentListId ) return null
    const svc = this._shop.orderlistV2
    if ( !svc ) return null
    return svc.lists[ this.currentListId ] || null
  }

  @action
  toggleSelectionModal = ( product = null ) => {
    this.isOpenSelectionModal = !this.isOpenSelectionModal
    if ( product && this.isOpenSelectionModal ) {
      this.currentProduct = product
    }
  }

  @action
  setCurrentList = ( list ) => {
    this.currentListId = list ? list.id : null
  }
}



// WEBPACK FOOTER //
// ./src/sdk/store/OrderlistStoreV2.js